module.exports = __webpack_public_path__ + "static/media/libismart.bb27873f.jpg";